export type ShopCardsMaxColumns = 'auto' | 'col-1' | 'col-2' | 'col-3';

/** Missing or unknown values keep the historical 2 / 3 / 4 scale. */
export function normalizeShopCardsMaxColumns(value: unknown): ShopCardsMaxColumns {
  if (value === 'col-1' || value === 'col-2' || value === 'col-3') {
    return value;
  }
  return 'auto';
}
